"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "mb-6" };
const vue_3 = require("vue");
const dataLayerLogin_1 = require("@/services/dataLayerLogin");
const GlobalError_vue_1 = __importDefault(require("@/components/GlobalError.vue"));
const SharedButton_vue_1 = __importDefault(require("@SharedVueComponents/SharedButton.vue"));
const SharedForm_vue_1 = __importDefault(require("@SharedVueComponents/SharedForm/SharedForm.vue"));
const SharedTextfield_vue_1 = __importDefault(require("@SharedVueComponents/SharedTextfield.vue"));
const store_1 = require("@/state/store");
const ocmAuthentication_1 = require("@/services/ocmAuthentication");
const BasicSkeleton_vue_1 = __importDefault(require("@SharedVueComponents/BasicSkeleton/BasicSkeleton.vue"));
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'LoginForm',
    setup(__props, { expose: __expose }) {
        let section = "login";
        const email = (0, vue_3.ref)("");
        const isSubmitLoading = (0, vue_3.ref)(false);
        const loginForm = (0, vue_3.ref)(null);
        const loginFormIsVisible = (0, vue_3.ref)(false);
        (0, vue_3.watch)(() => store_1.store.isLogin, () => {
            section = store_1.store.isLogin ? "login" : "registration";
            resetForm();
        });
        (0, vue_3.onMounted)(() => {
            section = store_1.store.isLogin ? "login" : "registration";
            if (store_1.store.isLandingPage)
                loginFormIsVisible.value = true;
        });
        function handleOnSubmit(fieldName, errorMessage) {
            errorMessage && (0, dataLayerLogin_1.pushEvent)(`submit_${fieldName}_error`, errorMessage);
        }
        function handleOnInput() {
            resetGlobalError();
        }
        function resetForm() {
            resetValidation();
            resetGlobalError();
        }
        function resetValidation() {
            if (loginForm.value) {
                loginForm.value.resetFormValidation();
            }
        }
        function resetGlobalError() {
            store_1.store.globalErrorMessages = [];
            store_1.store.httpErrorStatusCode = null;
        }
        function clearFormData() {
            resetForm();
            email.value = "";
        }
        function requestFirstLogin() {
            // TUB-18186 show sceleton instead of form the first time modal is opened
            // reason: prevent autofill freeze in Chrome-Browsers
            // timeout Value as defined in _popup.scss .animated
            window.setTimeout(() => {
                loginFormIsVisible.value = true;
            }, 400);
        }
        function handleOnChange(fieldName, errorMessage) {
            errorMessage && (0, dataLayerLogin_1.pushEvent)(`change_${fieldName}_error`, errorMessage);
        }
        async function handleSubmitClick() {
            isSubmitLoading.value = true;
            await submitForm();
        }
        async function submitForm() {
            const authData = {};
            if (email.value)
                authData["j_username"] = email.value;
            const success = await (0, ocmAuthentication_1.authenticate)(authData, section);
            if (!success)
                isSubmitLoading.value = false;
        }
        function ocmButtonClick() {
            (0, dataLayerLogin_1.pushEvent)("OCMButton");
        }
        __expose({
            clearFormData,
            requestFirstLogin,
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (loginFormIsVisible.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SharedForm_vue_1.default, {
                        key: 0,
                        ref_key: "loginForm",
                        ref: loginForm,
                        "show-error": false,
                        "error-message": "",
                        "no-submit-button-gap": true,
                        onSubmit: (0, vue_2.withModifiers)(handleSubmitClick, ["prevent"])
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(SharedTextfield_vue_1.default, {
                                modelValue: email.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                                "pattern-error-message": (0, vue_2.unref)(main_1.$t)('validation.email'),
                                name: "j_username",
                                "display-name": (0, vue_2.unref)(main_1.$t)('email-display-name'),
                                type: "email",
                                autocomplete: "username",
                                autocapitalize: "none",
                                autocorrect: "off",
                                inputmode: "email",
                                label: (0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? 'login.email_input_placeholder' : 'registration.email_input_placeholder'),
                                class: "mb-4",
                                "forced-error-message": (0, vue_2.unref)(store_1.store).httpErrorStatusCode === 422 ? ' ' : undefined,
                                maxlength: "126",
                                "validate-on-change": "",
                                onInput: handleOnInput,
                                onChange: _cache[1] || (_cache[1] = (_, data) => handleOnChange('email', data.errorMessage)),
                                onFormSubmit: _cache[2] || (_cache[2] = (_, data) => handleOnSubmit('email', data.errorMessage))
                            }, null, 8, ["modelValue", "pattern-error-message", "display-name", "label", "forced-error-message"]),
                            (0, vue_2.createVNode)(GlobalError_vue_1.default, { class: "mt-2" }),
                            (0, vue_2.createVNode)(SharedButton_vue_1.default, {
                                type: "submit",
                                class: "mt-2 w-full",
                                "is-loading": isSubmitLoading.value,
                                onClick: ocmButtonClick
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)((0, vue_2.unref)(store_1.store).isLogin ? "login.submit_button" : "registration.submit_button")), 1)
                                ]),
                                _: 1
                            }, 8, ["is-loading"])
                        ]),
                        _: 1
                    }, 512))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", null, [
                    (0, vue_2.createVNode)(BasicSkeleton_vue_1.default, { class: "mb-4 h-15" }),
                    (0, vue_2.createVNode)(BasicSkeleton_vue_1.default, { class: "mt-2 h-11.5" })
                ], 512), [
                    [vue_2.vShow, !loginFormIsVisible.value]
                ])
            ]));
        };
    }
});
